export default __webpack_public_path__ + "static/logo-freshcells-systems-engineering-df54cabfc1d9d2796fa9584d0c7e29c3.jpg";